import { combineReducers } from "redux";

const Index = (state = [], action) => {
  const { payload, toasts, intl } = action;
  switch (action.type) {
    case "SET_FOLDERS_DATA":
      return payload;
    case "SET_ASSIGN_FOLDER":
      let check = state.already_assigned.find((saa) => saa.id == payload.id);
      return {
        ...state,
        already_assigned: check
          ? state.already_assigned.filter((s) => s.id != payload.id)
          : [...state.already_assigned, payload],
      };
    case "SET_MULTI_ASSIGN_FOLDER":
      console.log("pay:", payload);
      console.log("sta:", action.status);
      let tmp = [];
      if (action.status) {
        tmp = [...state.already_assigned, ...payload];
        tmp = [...new Set(tmp)];
      } else {
        tmp = state.already_assigned.filter((aa) => {
          if (payload.map((p) => p.id).includes(aa.id)) {
            return false;
          }
          return true;
        });
      }

      return {
        ...state,
        already_assigned: tmp,
      };
    default:
      return state;
  }
};

const Errors = (state = [], action) => {
  const { payload } = action;
  switch (action.type) {
    case "SET_FOLDERS_ERROR":
      return payload;
    default:
      return state;
  }
};

export const reducer = combineReducers({
  Index,
  Errors,
});
